<template>
    <el-scrollbar class="login-container">
        <div class="login-wrapper">
            <div class="login-main">
                <div class="login-right">
                    <div class="title">{{appName}}</div>
                    <div class="title-text">{{titleText}}</div>
                    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm" label-position="top">
                        <el-form-item label="用户名" prop="name">
                            <el-input v-model="ruleForm.name" class="input-student" placeholder="请输入用户账号"
                                      @keydown.native.enter="submitForm('ruleForm')">
                                <i slot="prefix" class="iconfont">&#xea3d;</i>
                            </el-input>
                        </el-form-item>
                        <el-form-item label="密码" prop="password">
                            <el-input v-model="ruleForm.password" class="input-student" placeholder="请输入密码"
                                      type="password" @keydown.native.enter="submitForm('ruleForm')">
                                <i slot="prefix" class="iconfont">&#xe82e;</i>
                            </el-input>
                        </el-form-item>

                        <el-form-item class="login-form-actions">
                            <el-button class="login-button login-submit-btn" round type="primary"
                                       @click="submitForm('ruleForm')">登录
                            </el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
    </el-scrollbar>
</template>

<script>
    import {login} from '@/utils/apis'
    import config from "@/utils/config";

    export default {
        name: "Login",
        data() {
            return {
                appName: config.appName,
                titleText: 'ZHIBODIANSHANGYUNYING',
                ruleForm: {
                    name: '',
                    password: '',
                },
                rules: {
                    name: [
                        {required: true, message: '请输入用户账号', trigger: 'blur'},
                    ],
                    password: [
                        {required: true, message: '请输入密码', trigger: 'blur'},
                    ],
                }
            }
        },
        mounted() {
        },
        methods: {
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        let formData = new FormData()
                        formData.append('username', this.ruleForm.name)
                        formData.append('password', this.ruleForm.password)
                        login(formData).then(res => {
                            localStorage.setItem('role', res.data.role)
                            if (res.data.role === 5) {
                                localStorage.setItem('studentToken', res.data.token);
                                localStorage.setItem('nickname', res.data.nickname);
                                localStorage.setItem('studentAvatar', res.data.avatar);
                                localStorage.setItem('studentId', res.data.id)
                                localStorage.setItem('host_url', res.data.host_url)
                                localStorage.setItem('train_id', res.data.train_info.train_id)
                                localStorage.setItem('scriptId', res.data.train_info.script_id);
                                localStorage.setItem('train_name', res.data.train_info.train_name);
                                localStorage.setItem('paper_id', res.data.train_info.paper_id);
                                localStorage.setItem('class_id', res.data.train_info.class_id);
                                localStorage.setItem('start_time', res.data.train_info.start_time);
                                localStorage.setItem('end_time', res.data.train_info.end_time);
                                localStorage.setItem('advert_id', res.data.train_info.advert_id);
                                localStorage.setItem('websocket_host', res.data.websocket_host);
                                this.$message.success({
                                    type: 'success',
                                    message: res.msg,
                                    duration: 1000
                                })
                                this.$router.push('/exam/index')
                            }
                        })
                    } else {
                        return false;
                    }
                });
            },
        }
    }
</script>

<style scoped lang="scss">
    /* 手机端布局断点 */
    $login-mobile-bp: 768px;

    .login-container {
        width: 100%;
        max-width: 100vw;
        height: 100vh;
        box-sizing: border-box;

        & > ::v-deep .el-scrollbar__wrap {
            overflow-x: hidden;
            overflow-y: auto;
        }

        .login-wrapper {
            background: url("../assets/image/login_student.png") no-repeat center center;
            background-size: cover;
            min-width: 1100px;
            min-height: 100vh;
            height: auto;
            display: flex;
            align-items: center;
            justify-content: center;
            box-sizing: border-box;
        }
    }

    @media screen and (max-width: $login-mobile-bp) {
        .login-container {
            height: 100vh;
            height: 100dvh;

            & > ::v-deep .el-scrollbar__wrap {
                -webkit-overflow-scrolling: touch;
            }

            /* 整块登录区在视口内水平、垂直居中 */
            .login-wrapper {
                min-width: 0;
                min-height: 100vh;
                min-height: 100dvh;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                padding: max(16px, env(safe-area-inset-top, 0px))
                    max(16px, env(safe-area-inset-right, 0px))
                    max(24px, env(safe-area-inset-bottom, 0px))
                    max(16px, env(safe-area-inset-left, 0px));
            }
        }

        .login-main {
            width: 100%;
            max-width: min(420px, calc(100vw - 32px));
            display: flex;
            justify-content: center;
            box-sizing: border-box;
        }

        .login-right {
            width: 100%;
            flex: none;
            text-align: center;

            .title {
                font-size: clamp(26px, 6.5vw, 34px);
                text-align: center;
            }

            .title-text {
                font-size: 11px;
                letter-spacing: 1.5px;
                margin-top: 10px;
                text-align: center;
            }

            .demo-ruleForm {
                margin-top: 32px;
                margin-left: auto;
                margin-right: auto;
                max-width: 100%;
                width: 100%;
            }

            /* 顶栏标签与表单项内容整体居中 */
            ::v-deep .el-form-item__label {
                width: 100% !important;
                text-align: center;
                float: none;
                display: block;
                padding: 0;
            }

            ::v-deep .el-form-item__content {
                margin-left: 0 !important;
                text-align: center;
            }

            .login-form-actions {
                margin-top: 24px;

                ::v-deep .el-form-item__content {
                    display: flex;
                    justify-content: center;
                }
            }
        }

        ::v-deep.input-student {
            max-width: none;
            width: 100%;
            margin: 0 auto;

            .el-input__inner {
                max-width: none;
                font-size: 16px;
                text-align: left;
            }
        }

        .login-submit-btn {
            width: auto;
            min-width: 200px;
            max-width: 100%;
            padding-left: 40px;
            padding-right: 40px;
            -webkit-tap-highlight-color: transparent;
        }
    }

    .login-main {
        width: 100%;
        margin-left: 200px;
        overflow: hidden;
        display: flex;
        box-sizing: border-box;

        .login-left {
            img {
                display: block;
                max-width: 100%;
                max-height: 100%;
            }
        }

        .login-right {
            width: 1%;
            flex: 1;
            min-width: 0;

            .title {
                font-size: 48px;
                font-family: BigruixianRegularGB2;
                color: #FFFFFF;
                line-height: 1.2;
                word-break: break-word;
            }

            .title-text {
                font-size: 24px;
                font-family: BigruixianRegularGB2;
                font-style: italic;
                color: #FFFFFF;
                margin-top: 20px;
                letter-spacing: 8px;
                word-break: break-all;
            }

            .demo-ruleForm {
                margin-top: 90px;
                max-width: 520px;

                .el-form-item__content {
                    color: #fff;
                }
            }

            .login-form-actions {
                margin-top: 40px;

                ::v-deep .el-form-item__content {
                    line-height: normal;
                }
            }

            ::v-deep .el-form-item__label {
                color: #fff;
                font-family: Microsoft YaHei;
                opacity: 0.6;

                &:before {
                    content: '';
                }
            }
        }
    }

    ::v-deep.input-student {
        width: 100%;
        max-width: 520px;
        display: block;

        .el-input__inner {
            background-color: #070932;
            padding-left: 60px;
            border-top: none;
            border-left: none;
            border-right: none;
            width: 100%;
            max-width: 520px;
            box-sizing: border-box;
            color: #fff;
            font-size: 16px;
        }

        .el-input__prefix {
            left: 10px;
        }

        .iconfont {
            color: #fff;
            font-size: 20px;
        }

        :-webkit-autofill {
            -webkit-text-fill-color: #fff;
            transition: background-color 50000s ease-in-out 0s;
        }
    }

    .login-button {
        background: #4B45FF;
    }

    .login-submit-btn {
        width: 380px;
        max-width: 100%;
        box-sizing: border-box;
    }

    /* 基础 .login-main 写在上方媒体查询之后，手机端左偏移须在此再次声明才能覆盖 200px */
    @media screen and (max-width: $login-mobile-bp) {
        .login-main {
            margin-left: 0;
        }
    }
</style>
